import { withCompInfo, createComponentMapperModel, } from '@wix/editor-elements-integrations';
import { ARIA_LABEL_NAMESPACE, ARIA_LABEL_KEY, ARIA_LABEL_DEFAULT, } from './constants';
export const props = withCompInfo()(['translate'], ({ translate }, carmiProps) => {
    return {
        ...carmiProps,
        translations: {
            ariaLabel: translate(ARIA_LABEL_NAMESPACE, ARIA_LABEL_KEY) || ARIA_LABEL_DEFAULT,
        },
    };
});
export default createComponentMapperModel({ props });
//# sourceMappingURL=MediaContainer.mapper.js.map